// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"styles_breadcrumb__Z4ZCs","item":"styles_item__rQvnR","right_arrow":"styles_right_arrow__845SE"};